<ol class="breadcrumb">
  <li class="breadcrumb-item active">{{ 'title' | translate }}</li>
</ol>
<div class="search-content">
  <div class="container">
    <form [formGroup]="searchForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-group col-xl-6">
          <div class="form-check-inline col-xl-4">
            <input
              formControlName="partyType"
              class="form-check-input"
              type="radio"
              name="partyType"
              id="individual"
              [value]="partyTypeCode.INDIVIDUAL"
            />
            <label class="form-check-label" for="individual">
              {{ 'criteria.partyType.individual' | translate }}
            </label>
          </div>
          <div class="form-check-inline col-xl-4">
            <input
              formControlName="partyType"
              class="form-check-input"
              type="radio"
              name="partyType"
              id="institution"
              [value]="partyTypeCode.INSTITUTION"
            />
            <label class="form-check-label" for="institution">
              {{ 'criteria.partyType.institution' | translate }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group input-row">
        <label for="idCardNo" class="col-xl-2 col-form-label">{{ 'criteria.idCard' | translate }}</label>
        <div class="col-xl-3">
          <input formControlName="idCardNo" class="form-control" type="text" id="idCardNo" />
        </div>
        <label for="policyNo" class="col-xl-2 offset-xl-1 col-form-label">{{ 'criteria.policy' | translate }}</label>
        <div class="col-xl-3">
          <input formControlName="policyNo" class="form-control" type="text" id="policyNo" />
        </div>
      </div>
      <div class="form-group input-row">
        <label for="firstName" class="col-xl-2 col-form-label">{{ 'criteria.firstName' | translate }}</label>
        <div class="col-xl-3">
          <input formControlName="firstName" class="form-control" type="text" id="firstName" />
        </div>
        <label for="lastName" class="col-xl-2 offset-xl-1 col-form-label">{{ 'criteria.lastName' | translate }}</label>
        <div class="col-xl-3">
          <input formControlName="lastName" class="form-control" type="text" id="lastName" />
        </div>
      </div>
      <div class="form-group input-row">
        <label for="docType" class="col-xl-2 col-form-label">{{ 'criteria.docType' | translate }}</label>
        <div class="col-xl-3">
          <select formControlName="docType" class="form-control" id="docType">
            <option disabled selected value>{{ 'selectOption' | translate }}</option>
            <option [value]="documentType.EPOLICY">{{ 'criteria.docTypeList.ePolicy' | translate }}</option>
            <option [value]="documentType.ERENEWALNOTICE">{{
              'criteria.docTypeList.eRenewalNotice' | translate
            }}</option>
            <option [value]="documentType.PA_TAXDEDUCT">{{
              'criteria.docTypeList.PA_TAXDEDUCT' | translate
            }}</option>
          </select>
        </div>
      </div>
      <br />
      <div class="form-group input-row">
        <div class="col-xl-4 offset-xl-8">
          <button type="submit" class="col-xl-4 btn btn-primary btn-search">{{ 'criteria.search' | translate }}</button>
          <button type="button" class="col-xl-4 btn btn-secondary" (click)="clear()">
            {{ 'criteria.clear' | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
  <hr />
  <div *ngIf="error" class="text-danger row-centered">
    {{ 'result.serviceError' | translate }}
  </div>
  <div #searchResultSection>
    <div *ngIf="!error && searchResult" class="container-fluid">
      <div class="text-right">
        <span>{{ 'result.tableGuide' | translate }}</span>
      </div>
      <table class="table table-bordered dataTable">
        <thead>
          <tr class="table-row row-centered">
            <th class="col-xl-1">{{ 'result.action' | translate }}</th>
            <th class="col-xl-1" appSortable [sortBy]="sortableName.PRODUCT_TYPE" (sort)="onSort($event)">
              {{ 'result.product' | translate }}
            </th>
            <th class="col-xl-2 col-fix-3" appSortable [sortBy]="sortableName.CONTRACT_NO" (sort)="onSort($event)">
              {{ 'result.policy' | translate }}
            </th>
            <th class="col-xl-2 col-fix-3" appSortable [sortBy]="sortableName.IDCARD_NO" (sort)="onSort($event)">
              {{ 'result.idCard' | translate }}
            </th>
            <th class="col-xl-2" appSortable [sortBy]="sortableName.FIRSTNAME" (sort)="onSort($event)">
              {{ 'result.name' | translate }}
            </th>
            <th class="col-xl-1" appSortable [sortBy]="sortableName.EXPIRED_DATE" (sort)="onSort($event)">
              {{ 'result.expired' | translate }}
            </th>
            <th
              class="col-xl-1 col-fix-2"
              appSortable
              [sortBy]="sortableName.LAST_SENT_DATE"
              direction="asc"
              (sort)="onSort($event)"
            >
              {{ 'result.lastSent' | translate }}
            </th>
            <th class="col-xl-1 col-fix-1" appSortable [sortBy]="sortableName.SENT_BY" (sort)="onSort($event)">
              {{ 'result.sentBy' | translate }}
            </th>
            <th class="col-xl-1 col-fix-1" appSortable [sortBy]="sortableName.DOCUMENT_TYPE" (sort)="onSort($event)">
              {{ 'result.docType' | translate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="searchResult.content">
          <tr
            *ngFor="let item of (searchResult.content | paginate: pageConfig)"
            class="table-row"
            [ngClass]="{ 'row-gray': isDateExpired(item.expiredDate) }"
          >
            <td class="col-xl-1 text-center">
              <button
                *ngIf="isUserCanPreviewAndResend"
                class="btn btn-action"
                [title]="'previewBtn' | translate"
                [ngClass]="{ 'text-danger': isFail(item.pdfStatus), 'text-secondary': isNotstart(item.pdfStatus) }"
                (click)="preview(item.pdfStatus, item.ePolicyId)"
              >
                <i class="fas fa-fw fa-file-pdf"></i>
              </button>
              <button
                *ngIf="isUserCanPreviewAndResend"
                class="btn btn-action pl-xl-1"
                [title]="'resendBtn' | translate"
                [ngClass]="{ 'text-danger': isFail(item.emailStatus), 'text-secondary': isNotstart(item.emailStatus) }"
                (click)="onClickResend(item)"
              >
                <i class="fas fa-fw fa-envelope"></i>
              </button>
              <button
                class="btn btn-action pl-xl-1"
                [title]="'sentHistoryBtn' | translate"
                (click)="onClickSentHistory(item)"
              >
                <i class="fas fa-fw fa-history"></i>
              </button>
            </td>
            <td class="col-xl-1">{{ item.productType | translate }}</td>
            <td class="col-xl-2 col-fix-3">{{ item.contractNo }}</td>
            <td class="col-xl-2 col-fix-3">{{ item.idCardNo || item.passportNo }}</td>
            <td class="col-xl-2">{{ item.firstName }} {{ item.lastName }}</td>
            <td class="col-xl-1">{{ item.expiredDate | dateLocale: lang }}</td>
            <td class="col-xl-1 col-fix-2">{{ item.lastSentDate | datetimeLocale: lang }}</td>
            <td class="col-xl-1 col-fix-1">{{ item.sentBy }}</td>
            <td class="col-xl-1 col-fix-1">{{ item.docType }}</td>
          </tr>
        </tbody>
        <tbody *ngIf="!searchResult.content || searchResult.content.length === 0">
          <tr role="row">
            <td class="row-centered text-danger" colspan="8">
              {{ 'result.notFound' | translate }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-sm-12 col-md-3"></div>
        <div *ngIf="searchResult.content && searchResult.content.length > 0" class="col-sm-12 col-md-6 row-centered">
          <pagination-controls (pageChange)="pageChanged($event)" responsive="true"></pagination-controls>
        </div>
      </div>
    </div>
  </div>
</div>
<ngx-loading [show]="loading"></ngx-loading>
